module.exports = __webpack_public_path__ + "static/img/preview-03.25de1c65.webp";